'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nonNegativeNumber = {};

exports.__exports = nonNegativeNumber;
